import React from 'react'
import { useIntl } from 'react-intl'

import { Modal } from '@slite/components'

// Plays the use-case hero video in a centered modal. `videoLink` is a YouTube
// embed id (the mock stores ids); ported from the old Super DemoVideoModal.
export const UseCaseVideoModal = ({
  isOpen,
  setIsOpen,
  videoLink,
}: {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  videoLink: string
}) => {
  const intl = useIntl()
  const videoUrl = `https://www.youtube.com/embed/${videoLink}?rel=0&autoplay=1&cc_load_policy=0`
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      size={1200}
      shouldCloseOnEsc
      className="flexbox flexbox-centered"
      // Render above the navbar (z-index 1000) so the video isn't covered.
      overlayStyle={{ zIndex: 1100 }}
    >
      <div
        style={{
          left: 0,
          width: '100%',
          height: 0,
          position: 'relative',
          paddingBottom: 'calc(min(67.7%, 85vh))',
          maxWidth: '85vw',
          borderRadius: 20,
        }}
        className="shadow-large overflow-hidden background-shade-100 transition"
      >
        <iframe
          src={videoUrl}
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            position: 'absolute',
            border: 0,
          }}
          allowFullScreen
          allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
          title={intl.formatMessage({
            id: 'solutions.usecase.video.title',
            defaultMessage: 'Use case video',
          })}
        ></iframe>
      </div>
    </Modal>
  )
}
